import React__default from 'react';

const SettingsList = ({ children })=>{
    return /*#__PURE__*/ React__default.createElement("dl", {
        style: {
            margin: 0
        }
    }, children);
};

export { SettingsList };
//# sourceMappingURL=SettingsList.mjs.map
